export const Benfit = (props) => {
    return (
        <>
        <div className="benefits-container">
        <h2>Benefits of Home Serves India</h2>
        <div className="benefits-grid">
        {props.data
            ? props.data.map((d, i) => (
                <div className="benefit-card" key={i}>
                <div className="benefit-content">
                  <i className={`fa ${d.icon} benefit-icon`}></i>
                  <div className="benefit-text">
                    <h3>{d.title}</h3>
                    <p>{d.description}</p>
                  </div>
                </div>
              </div>
          ))
          : 'Loading...'}
        </div>
      </div>
        </>
    )
}